export const isDisableInput = (field, userInfo, singleOrderData, ...props) => {
  if (field === "country") {
    if (userInfo.userType === "superAdmin") {
      if (
        userInfo.permission.update_booking_order &&
        userInfo.permission.can_update_booking_order_status &&
        singleOrderData
      ) {
        if (singleOrderData && singleOrderData.status !== "delivered") {
          return false;
        } else {
          return true;
        }
        return false; // New logic: Super admin with permissions can edit country
      } else {
        return false;
      }
    } else {
      return true;
    }
  }

  if (field === "fromLocation") {
    const { fixedFromLocation, selectedCountry } = props;

    if (fixedFromLocation || selectedCountry === null) {
      return true;
    }

    if (userInfo.userType === "store" && !singleOrderData) {
      return true;
    }

    if (singleOrderData && singleOrderData.userType.type === "store") {
      return true; // New logic: If order created by store user, no one can edit from location
    }

    // if (
    //   singleOrderData &&
    //   userInfo.permission.update_booking_order &&
    //   userInfo.permission.can_update_booking_order_status
    // ) {
    //   if (!["pending", "cvit", "assigned"].includes(singleOrderData?.status)) {
    //     return true;
    //   }
    // }

    if (
      singleOrderData &&
      !userInfo.permission.update_booking_order &&
      userInfo.permission.can_update_booking_order_status
    ) {
      return true;
    }

    // if (
    //   singleOrderData &&
    //   userInfo.permission.update_booking_order &&
    //   !["pending", "cvit", "assigned"].includes(singleOrderData?.status)
    // ) {
    //   return true;
    // }

    return singleOrderData?.status === "delivered"; // New logic: If status is not delivered, they can change from location
  }

  if (["toLocation", "sealBag"].includes(field)) {
    const { selectedCountry } = props;

    if (selectedCountry === null) {
      return true;
    }

    // if (
    //   singleOrderData &&
    //   userInfo.permission.update_booking_order &&
    //   userInfo.permission.can_update_booking_order_status
    // ) {
    //   if (!["pending", "cvit", "assigned"].includes(singleOrderData?.status)) {
    //     return true;
    //   }
    // }

    if (
      singleOrderData &&
      !userInfo.permission.update_booking_order &&
      userInfo.permission.can_update_booking_order_status
    ) {
      return true;
    }

    // if (
    //   singleOrderData &&
    //   userInfo.permission.update_booking_order &&
    //   !["pending", "cvit", "assigned"].includes(singleOrderData?.status)
    // ) {
    //   return true;
    // }

    return singleOrderData?.status === "delivered"; // New logic: If status is not delivered, toLocation can be changed
  }

  if (
    [
      "UNIT",
      "TYPE",
      "PRIORITY",
      "transferOrderNo",
      "pickupDate",
      "pickupTime",
      "remarks",
    ].includes(field)
  ) {
    if (
      singleOrderData &&
      userInfo.permission.update_booking_order &&
      userInfo.permission.can_update_booking_order_status
    ) {
      // if (!["pending", "cvit", "assigned"].includes(singleOrderData?.status)) {
      //   return true;
      // }
    }

    if (
      singleOrderData &&
      !userInfo.permission.update_booking_order &&
      userInfo.permission.can_update_booking_order_status
    ) {
      return true;
    }

    // if (
    //   singleOrderData &&
    //   userInfo.permission.update_booking_order &&
    //   !["pending", "cvit", "assigned"].includes(singleOrderData?.status)
    // ) {
    //   return true;
    // }

    return false; // New logic: On any status, order can be editable
  }
};

export const isDisableSelect = {
  control: (state) => (state.isDisabled ? "select-control-disabled" : ""),
  singleValue: (state) => (state.isDisabled ? "select-text-disabled" : ""),
};
